import { RewardDto } from '../../../models/dtos/reward.dto';
import { RewardRequest } from '../../../models/requests/reward.request';
import axios from '../../axios';

export default async function getRewardRequest(request: RewardRequest): Promise<RewardDto> {
  const response = await axios.get<RewardDto>(
    `${process.env.REACT_APP_BASE_URL}/reward/get/transaction`,
    {
      params: {
        ...request
      }
    }
  );
  return response.data;
}
